import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { MessageService } from 'src/app/services/message.service';
import { CommonService } from 'src/app/services';
import { stripHtmlTags } from 'src/app/utils';
import { Subject, Subscription } from 'rxjs';
import { MarkAsRead, UsersHistory } from 'src/app/models/messaging-model';
import { FiltersEnum, IdentifierTypeEnum } from 'src/app/models/messaging.enum';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { WebPubSubService } from 'src/app/services/WebPubSubService';
import { UnreadCountService } from '../service/UnreadCountService';

@Component({
  selector: 'app-spc-users-list',
  templateUrl: './spc-users-list.component.html',
  styleUrls: ['./spc-users-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SpcUsersListComponent implements OnInit {
  @Output() userSelected = new EventEmitter<any>();
  @Input() filterPeriod: string = FiltersEnum.ALLHISTORY;
  @Input() searchText: string = '';
  @Input() activeInactive!: boolean;
  @Input() patientID!: string;
  @Input() isFrmMessegingTab: any;
  markAsReadFlag:boolean = false;
  pharmacyName:any;
  unsubscribe$: Subject<void> = new Subject();
  auth0_token:any;
  npi:any;
  userList: any[] = [];
  avatarUrl: string = '';
  selectedUser: any;
  filteredList: any[] = [];
  isFrmMesTab:boolean = false;
  PageNumber = 1;
  pageSize = 20;
  isLoading = false;
  hasMore = true;
  profilePicMap: Record<string, string> = {};
  private messageSubscription: Subscription;
  userDeletedImgage: boolean;
  constructor(
    private _msgServ: MessageService,
    private _userServ: UserService,
    private _commonServ: CommonService,
    private webPubSubService: WebPubSubService,
    private _unreadCountService: UnreadCountService) {}

  ngOnInit(): void {
    this.isFrmMesTab = this.isFrmMessegingTab ? this.isFrmMessegingTab : false;
    this.pharmacyName = this._userServ.getToken("PharmacyName");
    this.npi = this._userServ.getToken("UniquePharmacyId");
    this.messageSubscription = this.webPubSubService.newMessageReceived$.subscribe((hasNewMessage: any) => {
      if (hasNewMessage) {
        const patientID = hasNewMessage?.patientID;
        const newMessage = hasNewMessage?.lastMessage;
        const receivedAt = hasNewMessage?.lastMessageReceivedAt;
        const userToUpdate = this.filteredList.find(user => user?.identifier === patientID);
        if (userToUpdate) { 
            userToUpdate.lastMessage = newMessage;
            userToUpdate.lastMessageReceivedAt = receivedAt;
              if (this.activeInactive && this.patientID) {
                  const activeUser = this.filteredList.find(user => user?.identifier === this.patientID);
                  if (activeUser) {
                    activeUser.unreadCount = 0;
                    this.markAsReadFlag = true; 
                    this.markAsRead();
                  }
              } else { 
                  userToUpdate.unreadCount = (userToUpdate.unreadCount || 0) + 1;
              }
        }
      }
    });
    if(!this.isFrmMesTab){
        this.loadUsers();
    } 
  }
  private capitalizeName(name: string): string {
    return name
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }
loadUsers() {
  if (!this.npi || this.isLoading || !this.hasMore) return;
  this.isLoading = true;
  const payload: UsersHistory = {
    Recipient: { Identifier: this.npi, IdentifierType: IdentifierTypeEnum.NPI },
    pharmacyNPI: this.npi,
    PageNumber: this.PageNumber,
    PageSize: this.pageSize,
    SearchText: this.searchText,
  };
  if(!this.isFrmMesTab){
  this._msgServ.postMessageChatSummary(payload)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res: any) => {
      const batch =  res?.communicationSummary || [];
      if (batch.length < this.pageSize) this.hasMore = false;
        batch.forEach(msg => {
        if (msg?.userName) {
          msg.userName = this.capitalizeName(msg.userName);
        }
      });
      // append users
      this.userList = [...this.userList, ...batch];
      this.applyFilter(this.searchText);
      // fetch profile pic docIds
      setTimeout(async () => {
      const docIds = batch
        .map(u => u.profilePictureId)
        .filter(id => id);
      if (docIds?.length && !this.isFrmMesTab) {
        const picMap = await this.downloadProfilePics(docIds);
        this.profilePicMap = { ...this.profilePicMap, ...picMap };

        this.userList.forEach(u => {
          if (u?.profilePictureId && this.profilePicMap[u?.profilePictureId]) {
            u.profilePicUrl = this.profilePicMap[u?.profilePictureId];
          }else {
          u.profilePicUrl = null;
          }
        });
      }
    },0);
      this.PageNumber++;
      this.isLoading = false;
    });
  }

}

  ngOnChanges() {
   if (this.searchText !== undefined) {

    this.PageNumber = 1;
    this.hasMore = true;
    this.userList = [];
    this.filteredList = [];

    this.loadUsers();
    setTimeout(() => {
      this.applyFilter(this.searchText);
    });
  }
    
  }
  applyFilter(searchText: string = ''): void {
    const now = moment();
    const lowerCaseSearchText = searchText.toLowerCase(); 
    this.filteredList = this.userList.filter(user => {

      const userName = user.userName ? user.userName.toLowerCase() : '';

      const matchesSearchText = userName.includes(lowerCaseSearchText);

      const messageDate = moment(user.lastMessageReceivedAt);
      let matchesDate = false;

      switch (this.filterPeriod) {
        case FiltersEnum.TODAY:
          matchesDate = messageDate.isSame(now, 'day');
          break;
        case FiltersEnum.LASTONEWEEK:
          matchesDate = messageDate.isAfter(moment().subtract(1, 'weeks'));
          break;
        case FiltersEnum.LASTONEMONTH:
          matchesDate = messageDate.isAfter(moment().subtract(1, 'months'));
          break;
        case FiltersEnum.LASTSIXMONTHS:
          matchesDate = messageDate.isAfter(moment().subtract(6, 'months'));
          break;
        case FiltersEnum.LASTONEYEAR:
          matchesDate = messageDate.isAfter(moment().subtract(1, 'years'));
          break;
        default:
          matchesDate = true;
          break;
      }

      return matchesSearchText && matchesDate;
    });
  }

  userSelect(userData:any){
    this.selectedUser = userData;
    this.patientID = userData?.identifier;
    this.userSelected.emit(userData); 
    this.markAsReadFlag = true; 
    this.markAsRead();
  }
  isSelected(user: any): boolean {
    return this.selectedUser && this.selectedUser?.identifier === user?.identifier;
  }
  getRelativeTime(time: string): string {
    if (!time) return ''; 
    const now = moment();
    const messageTime = moment(time);
    const diffInDays = now.diff(messageTime, 'days');
  
    if (diffInDays < 2) {
      return messageTime.fromNow();
    } else {
      return messageTime.format('MM/DD/YY');
    }
  }
  trackByUserId(index: number, item: any): string {
    return item.userId || index; // Use a unique identifier
  }
  markAsRead(){
    if(this.markAsReadFlag && this.npi && this.patientID){
        const usersPayLoad: MarkAsRead = {
                Sender: {
                    Identifier: this.patientID,
                    IdentifierType: IdentifierTypeEnum.PATIENT
                },
                Recipient: {
                    Identifier: this.npi,
                    IdentifierType: IdentifierTypeEnum.NPI
                },
                pharmacyNPI: this.npi
        };
        this._msgServ.postMessageMarkAsRead(usersPayLoad)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res: any['StatusCode']) => {
            if (res) { 
              if(res?.StatusCode === 0){
                  this.markAsReadFlag = false;
                  this._unreadCountService.getUnreadCounts();
                  if(!this.isFrmMesTab){
                      this.loadUsers();
                  } 
              }
            }
        });
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
  }
  getDisplayMessage(message: string): string {
    this.userDeletedImgage = false;
  if (!message) return '';
  const stripped = stripHtmlTags(message);
 if ((/You deleted this message for you/i.test(stripped)) || (/You deleted this image for you/i.test(stripped))) {
  this.userDeletedImgage = true;
  return '(Image)';
}else if (/You deleted this image for everyone/i.test(stripped)){
    return 'This message was deleted';
  }else{
  const sasUrlRegex = /https:\/\/.*blob\.core\.windows\.net\/.*(\?|&)(sv|sig)=/i;
  if (sasUrlRegex.test(message.trim()) && message.trim().startsWith('http')) {
    return '(Image)';
  }
  if (sasUrlRegex.test(message)) {
    return message.replace(sasUrlRegex, '(Image)');
  }else {
    return message;
  }
  }

 
}
async downloadProfilePics(docIds: string[]): Promise<Record<string, string>> {
  const payload = {
    Pharmacy: {
      IdentifierType: 0,
      Identifier: this.npi,
      Name: this.pharmacyName
    },
    Application: { Id: 1, Name: "Primerx" },
    DocumentIds: docIds,
    RelatedEntity: { EntityType: 0, Identifier: this.npi, Name: this.pharmacyName },
    DocumentReference: 2,
    StatusCode : 1

  };

  try {
    const resp: any = await this._msgServ.downloadImage(payload).toPromise();
    const map: Record<string, string> = {};

    if (Array.isArray(resp?.documents)) {
      resp.documents.forEach(d => {
        const doc = d?.document;
        if (doc?.id) map[doc.id] = doc.url;
      });
    }
    return map;   
  } catch {
    return {};
  }
}
onScrollDown(index: number) {
  if (index >= this.userList.length - 5 && !this.isLoading && this.hasMore) {
    this.loadUsers();
  }
}


}
